import { compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import moment from 'moment';
import { getDate } from '../../appointments/appointmentSelector';

const sideBySideShowForCurrentDay = compose(
  connect(state => ({
    day: getDate(state),
  })),
  branch(
    props => !moment(props.day).isSame(moment(), 'day'),
    renderNothing,
  ),
);

export default sideBySideShowForCurrentDay;
